module.exports = __webpack_public_path__ + "static/img/m_name.1066f17.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/zxrx/m_name.png
// module id = xLHq
// module chunks = 7